export default function logicDataActions(logic) {
    return dispatch => {
        dispatch({
            type:'GET_LOGIC_DATA',
            payload:logic
        });
    }
}
